// extracted by mini-css-extract-plugin
export var lg = "_3h-4";
export var md = "_3h-3";
export var sm = "_3h-2";
export var xs = "_3h-1";
export var xxs = "_3h-0";